
const commonApi = {
    getRouterObjByName (routers, name) {
        if (!name || !routers || !routers.length) {
            return null;
        }
        // debugger;
        let routerObj = null;
        for (let item of routers) {
            if (item.name === name) {
                return item;
            }
            routerObj = util.getRouterObjByName(item.children, name);
            if (routerObj) {
                return routerObj;
            }
        }
        return null;
    },

    /**
     * Created by donghang on 17/4/14.
     *
     * @param uid Number  服务id
     * @param size String 图片尺寸
     * @param prefixUrl String 自定义图片域名
     */
    getUserAvatar(uid, size, prefixUrl) {
        if (!uid) return '//avatar.zbjimg.com/001/23/34/200x200_avatar_56.jpg!big';//如果没有传入用户ID，则返回国默认图片地址

        var maxIUserid = "000000000" + uid,
            iUserid = maxIUserid.substr(maxIUserid.length - 9, 9),
            sImgUrl;

        size = size || 'small';
        prefixUrl ? sImgUrl = prefixUrl + '/' : sImgUrl = '//avatar.zbjimg.com/';

        sImgUrl = sImgUrl
            + iUserid.substr(0, 3)
            + '/' + iUserid.substr(3, 2)
            + '/' + iUserid.substr(5, 2)
            + '/200x200_avatar_'
            + iUserid.substr(7, 2) + '.jpg!' + size;

        return sImgUrl;
    },
    getAccessList(access){
        let accessList = [];
        if(typeof access === 'string'){
            accessList = [access]
        }else if(access instanceof Array){
            accessList = access;
        }
        return accessList;
    },
    getImgUrl(imgurl) {
        let result = '';
        if (imgurl.indexOf('http') == 0) {
            result = imgurl;
        } else if(imgurl.indexOf('operate=imageMogr2') > 0){
            result = `/resource/redirect?key=${imgurl}|imageView2/2/w/200/h/200`;
        } else {
            result = `${ZBJInfo.qiniuUploadTokenUrl}/resource/redirect?key=${imgurl}`;
        }
        return decodeURIComponent(result);
    },
    htmlEncode(html) {
        var temp = document.createElement ("div");
        (temp.textContent != undefined ) ? (temp.textContent = html) : (temp.innerText = html);
        var output = temp.innerHTML;
        temp = null;
        return output;
    },
    htmlDecode(text) {
        var temp = document.createElement("div");
        temp.innerHTML = text;
        var output = temp.innerText || temp.textContent;
        temp = null;
        return output;
    }
};

export default commonApi;